import { Box, Button, IconButton, Typography } from "@mui/material";

import { styled, keyframes } from '@mui/material/styles';

// Animação sutil de pulse
const pulseAnimation = keyframes`
	0%, 100% { opacity: 1; }
	50% { opacity: 0.75; }
`;

// Animação de breathing para o ícone na versão page
const breathingAnimation = keyframes`
	0%, 100% { transform: scale(1); opacity: 0.8; }
	50% { transform: scale(1.05); opacity: 1; }
`;

// ========== ESTILOS DEFAULT ==========

// Display do tempo
export const TimeDisplay = styled(Typography)(({ status, simple }) => ({
	color:  simple ? '#000000' : '#ffffff' 
	// : status === 'exceeded'
	// 	? '#c62828'
	// 	: status === 'warning'
	// 		? '#e65100'
	// 		: simple ? '#000000' : '#ffffff'
}));

// Separador
export const Separator = styled('span')(({ status, simple }) => ({
	color: simple ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255, 255, 255, 0.5)',
		// : status === 'exceeded'
		// 	? 'rgba(211, 47, 47, 0.5)'
		// 	: status === 'warning'
		// 		? 'rgba(237, 108, 2, 0.5)'
		// 		: simple ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255, 255, 255, 0.5)',
	fontWeight: 400,
	margin: '0 2px',
}));


// ========== ESTILOS PARA VERSÃO HEADER ==========

// Container principal do timer - compacto para header
export const TimerContainer = styled(Box)(({ status }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	padding: '6px 12px',
	borderRadius: '8px',
	minHeight: '36px',
	backgroundColor: status === 'exceeded'
		? 'rgba(244, 67, 54, 0.08)'
		: status === 'warning'
			? 'rgba(255, 152, 0, 0.08)'
			: 'rgba(255, 255, 255, 0.08)',
	border: `2px solid ${'rgba(255, 255, 255, 0.9)'}`,
		// status === 'exceeded'
		// ? 'rgba(244, 67, 54, 0.2)'
		// : status === 'warning'
		// 	? 'rgba(255, 152, 0, 0.2)'
		// 	: 'rgba(255, 255, 255, 0.2)'
		// }`,
	boxShadow: status === 'exceeded'
		? '0 8px 32px rgba(244, 67, 54, 0.2)'
		: status === 'warning'
			? '0 8px 32px rgba(255, 152, 0, 0.2)'
			: '0 8px 32px rgba(255, 255, 255, 0.2)',
	animation: status === 'exceeded'
		? `${pulseAnimation} 1.5s ease-in-out infinite`
		: 'none',
	cursor: 'default',
	transition: 'all 0.2s ease'
}));

// Botão de encerrar pausa
export const EndBreakButton = styled(IconButton)(({ status }) => ({
	padding: '4px',
	color: status === 'exceeded'
		? '#d32f2f'
		: status === 'warning'
			? '#ed6c02'
			: '#ffffff',
	'&:hover': {
		backgroundColor: status === 'exceeded'
			? 'rgba(244, 67, 54, 0.15)'
			: status === 'warning'
				? 'rgba(255, 152, 0, 0.15)'
				: 'rgba(255, 255, 255, 0.15)',
	},
	'& svg': {
		fontSize: '1.2rem',
	},
}));


// ========== ESTILOS PARA VERSÃO PAGE ==========

// Container principal para página inteira
export const PageContainer = styled(Box)(({ status, backgroundColorPage = null }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	padding: '40px',
	borderRadius: '24px',
	backgroundColor: backgroundColorPage || (status === 'exceeded'
		? 'rgba(244, 67, 54, 0.08)'
		: status === 'warning'
			? 'rgba(255, 152, 0, 0.08)'
			: 'rgba(0, 0, 0, 0.08)'),
	border: `2px solid ${status === 'exceeded'
		? 'rgba(244, 67, 54, 0.2)'
		: status === 'warning'
			? 'rgba(255, 152, 0, 0.2)'
			: 'rgba(0, 0, 0, 0.2)'
		}`,
	boxShadow: status === 'exceeded'
		? '0 8px 32px rgba(244, 67, 54, 0.15)'
		: status === 'warning'
			? '0 8px 32px rgba(255, 152, 0, 0.15)'
			: '0 8px 32px rgba(0, 0, 0, 0.15)',
	transition: 'all 0.3s ease',
	minWidth: '320px',
	maxWidth: '480px',
	margin: '0 auto',
	marginTop: '24px',
	marginBottom: '24px',
}));

// Ícone grande de pausa
export const PageIcon = styled(Box)(({ status }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '80px',
	height: '80px',
	borderRadius: '50%',
	backgroundColor: status === 'exceeded'
		? 'rgba(244, 67, 54, 0.15)'
		: status === 'warning'
			? 'rgba(255, 152, 0, 0.15)'
			: 'rgba(0, 0, 0, 0.1)',
	marginBottom: '24px',
	animation: `${breathingAnimation} 3s ease-in-out infinite`,
	'& svg': {
		fontSize: '40px',
		color: status === 'exceeded'
			? '#d32f2f'
			: status === 'warning'
				? '#ed6c02'
				: '#000000',
	},
}));

// Nome do motivo da pausa
export const BreakReasonName = styled(Typography)(({ status }) => ({
	fontSize: '1.5rem',
	fontWeight: 600,
	color: '#000000' ,
	// : status === 'exceeded'
	// 	? '#c62828'
	// 	: status === 'warning'
	// 		? '#e65100'
	// 		: '#000000',
	marginBottom: '8px',
	textAlign: 'center',
}));

// Label "Em pausa"
export const StatusLabel = styled(Typography)(({ status }) => ({
	fontSize: '0.875rem',
	fontWeight: 500,
	color: 'rgba(0, 0, 0, 0.7)',
	// : status === 'exceeded'
	// 	? 'rgba(198, 40, 40, 0.7)'
	// 	: status === 'warning'
	// 		? 'rgba(230, 81, 0, 0.7)'
	// 		: 'rgba(0, 0, 0, 0.7)',
	textTransform: 'uppercase',
	letterSpacing: '1px',
	marginBottom: '24px',
}));

// Display do tempo grande
export const PageTimeDisplay = styled(Typography)(({ status }) => ({
	fontFamily: '"Roboto Mono", monospace',
	fontSize: '3rem',
	fontWeight: 700,
	color: '#000000',
	// : status === 'exceeded'
	// 	? '#d32f2f'
	// 	: status === 'warning'
	// 		? '#ed6c02'
	// 		: '#000000',
	letterSpacing: '2px',
	animation: status === 'exceeded'
		? `${pulseAnimation} 1s ease-in-out infinite`
		: 'none',
}));

// Separador para versão page
export const PageSeparator = styled('span')(({ status }) => ({
	fontSize: '1.5rem',
	fontWeight: 300,
	color: status === 'exceeded'
		? 'rgba(211, 47, 47, 0.5)'
		: status === 'warning'
			? 'rgba(237, 108, 2, 0.5)'
			: 'rgba(0, 0, 0, 0.5)',
	margin: '0 8px',
}));

// Tempo limite
export const LimitTimeDisplay = styled(Typography)(({ status }) => ({
	fontFamily: '"Roboto Mono", monospace',
	fontSize: '1.25rem',
	fontWeight: 500,
	color: 'rgba(0, 0, 0, 0.8)',
}));

// Container do tempo
export const TimeWrapper = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	marginBottom: '32px',
});

// Botão de encerrar pausa (versão page)
export const EndBreakPageButton = styled(Button)(({ status }) => ({
	padding: '12px 32px',
	borderRadius: '12px',
	fontSize: '1rem',
	fontWeight: 600,
	textTransform: 'none',
	backgroundColor: status === 'exceeded'
		? '#d32f2f'
		: status === 'warning'
			? '#ed6c02'
			: '#000000',
	color: '#ffffff',
	'&:hover': {
		backgroundColor: status === 'exceeded'
			? '#b71c1c'
			: status === 'warning'
				? '#e65100'
				: '#000000',
	},
	'& .MuiButton-startIcon': {
		marginRight: '8px',
	},
}));

// Informação adicional (tempo excedido, etc)
export const InfoText = styled(Typography)(({ status }) => ({
	fontSize: '0.875rem',
	color: status === 'exceeded'
		? '#d32f2f'
		: status === 'warning'
			? '#ed6c02'
			: 'rgba(0, 0, 0, 0.6)',
	marginTop: '16px',
	textAlign: 'center',
}));

export const InfoTextContainer = styled(Box)(() => ({
	marginTop: '16px',
	textAlign: 'center',
}));